// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 60px;
  transition: all 200ms linear;
  z-index: 20;
}
:host mat-toolbar {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  padding: 0 10px;
}
:host .left,
:host .right {
  display: flex;
  flex-direction: row;
}
:host .right {
  height: 100%;
}
:host .left {
  min-width: 0;
}
:host .left .du-title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
:host .left .du-title h3,
:host .left .du-title h4 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .left .du-title h3 {
  font-size: 18px;
  margin: auto 0;
}
:host .left .du-title h4 {
  font-size: 17px;
  margin-top: -11px;
}
:host button,
:host o-history-switch,
:host o-historic {
  margin: auto 4px;
}
:host .synchro-icon {
  cursor: unset;
}
:host .beyblade {
  animation: rotate 2s infinite linear;
}

@media print {
  :host {
    display: none;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./apps/viewer/src/app/header/header.component.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,4BAAA;EACA,WAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;AADJ;AAIE;;EAEE,aAAA;EACA,mBAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;AAME;EAEE,YAAA;AALJ;AAOI;EACE,aAAA;EAEA,sBAAA;EACA,YAAA;AANN;AAQM;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AANR;AASM;EACE,eAAA;EACA,cAAA;AAPR;AAUM;EACE,eAAA;EACA,iBAAA;AARR;AAaE;;;EAGE,gBAAA;AAXJ;AAcE;EACE,aAAA;AAZJ;AAeE;EACE,oCAAA;AAbJ;;AAiBA;EACE;IACE,aAAA;EAdF;AACF;AACA,4sEAA4sE","sourcesContent":["@import \"libs/theme/orion-theme\";\n\n:host {\n  height: 60px;\n  transition: all 200ms linear;\n  z-index: 20;\n\n  mat-toolbar {\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n    justify-content: space-between;\n    padding: 0 10px;\n  }\n\n  .left,\n  .right {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .right {\n    height: 100%;\n  }\n\n  .left {\n    // SPEC: Needed for ellipsis\n    min-width: 0;\n\n    .du-title {\n      display: flex;\n      // SPEC: Needed for ellipsis\n      flex-direction: column;\n      min-width: 0;\n\n      h3,\n      h4 {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      h3 {\n        font-size: 18px;\n        margin: auto 0;\n      }\n\n      h4 {\n        font-size: 17px;\n        margin-top: -11px;\n      }\n    }\n  }\n\n  button,\n  o-history-switch,\n  o-historic {\n    margin: auto 4px;\n  }\n\n  .synchro-icon {\n    cursor: unset;\n  }\n\n  .beyblade {\n    animation: rotate 2s infinite linear;\n  }\n}\n\n@media print {\n  :host {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
